// extracted by mini-css-extract-plugin
export default {"formContainer":"addCar_formContainer__BNA3v","formGroup":"addCar_formGroup__-pRVE"};